// Organization structured data for EqualAccess
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "EqualAccess B.V.",
  "alternateName": ["EqualAccess", "Equal Access", "Toegankelijkheid Expert"],
  "url": "https://equalaccess.nl",
  "logo": "https://equalaccess.nl/favicon.png",
  "description": "Toegankelijkheid specialist voor websites en apps. Expert begeleiding voor digitale toegankelijkheid, WCAG compliance en EU Toegankelijkheidswet.",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "NL"
  },
  "sameAs": [],
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer service",
    "availableLanguage": ["Dutch", "English"]
  },
  "knowsAbout": [
    "Toegankelijkheid",
    "Digitale toegankelijkheid", 
    "Website toegankelijkheid",
    "WCAG",
    "EU Toegankelijkheidswet",
    "Accessibility",
    "Web accessibility"
  ]
};

// WebSite structured data with search action
export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "EqualAccess B.V. - Toegankelijkheid Expert",
  "url": "https://equalaccess.nl",
  "description": "Toegankelijkheid specialist voor websites en apps. Expert begeleiding voor digitale toegankelijkheid, WCAG compliance en EU Toegankelijkheidswet.",
  "inLanguage": ["nl", "en"],
  "publisher": {
    "@type": "Organization",
    "name": "EqualAccess B.V."
  },
  "keywords": "toegankelijkheid, digitale toegankelijkheid, website toegankelijkheid, WCAG, accessibility"
};

// Service structured data
export const createServiceSchema = (
  name: string,
  description: string,
  url: string
) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": name,
  "description": description,
  "url": url,
  "provider": {
    "@type": "Organization",
    "name": "EqualAccess B.V.",
    "url": "https://equalaccess.nl"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Netherlands"
  },
  "serviceType": "Digitale Toegankelijkheid Consultancy"
});

// FAQ structured data
export const createFAQSchema = (
  faqs: Array<{ question: string; answer: string }>
) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map((faq) => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

// BreadcrumbList structured data
export const createBreadcrumbSchema = (
  items: Array<{ name: string; url: string }>
) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

// Article structured data for knowledge base pages
export const createArticleSchema = (
  headline: string,
  description: string,
  url: string,
  datePublished: string,
  dateModified?: string
) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": headline,
  "description": description,
  "url": url,
  "datePublished": datePublished,
  "dateModified": dateModified || datePublished,
  "author": {
    "@type": "Organization",
    "name": "EqualAccess B.V.",
    "url": "https://equalaccess.nl"
  },
  "publisher": {
    "@type": "Organization",
    "name": "EqualAccess B.V.",
    "logo": {
      "@type": "ImageObject",
      "url": "https://equalaccess.nl/favicon.png"
    }
  },
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": url
  }
});

// LocalBusiness structured data
export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "EqualAccess B.V.",
  "description": "Expert begeleiding die MKB-bedrijven helpt om EU Toegankelijkheidswet compliant te worden.",
  "url": "https://equalaccess.nl",
  "logo": "https://equalaccess.nl/favicon.png",
  "priceRange": "€€",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "NL"
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    "opens": "09:00",
    "closes": "17:00"
  }
};
